export default "__VITE_ASSET__9nLYLJ_X__"